/**
 * filter
 */

import $ from "jquery";
import Component, { nextTick } from "../../js/lib/component";
import Query from "../../js/lib/query";

const classList = {
  root: ".js-filter",
  fieldset: ".js-filter-fieldset",
  toggle: ".js-filter-toggle",
  tooltip: ".js-filter-tooltip",
  fields: ".js-filter-fields"
};

export default class Filter extends Component {
  init() {
    nextTick().then(() => {
      this.$.fieldset
        .filter((i, fieldset) => !$(fieldset).is(".is-open"))
        .find(this.$.fields)
        .hide();

      this.delay = 800;

      this.ranges = this.childs("Range");
      this.selects = this.childs("Select");

      this.setState({ params: this.getParams() });

      this.$.tooltip.remove();
      this.inited = true;
      this.$.root.addClass("is-inited");
    });
  }
  events() {
    this.$.root.on("reset", () => this.reset());
    this.$.root.on("submit", e => this.submit(e));
    this.$.toggle.on("click", e => this.toggle($(e.currentTarget)));
    this.$.fields.on("change", e => this.change(e));
  }
  reset() {
    this.ranges.forEach(range => range.reset());
    this.selects.forEach(select => select.reset());
    this.setState({ params: {} });
    this.hideCheckedFieldsets();
    this.$.root.find('input[type="checkbox"]').each((i, checkbox) => {
      const $checkbox = $(checkbox);
      $checkbox.prop("checked", false).removeAttr("checked");
    });

    // Hard reset URL even if products component didn't catch event
    const cleanPath = `${location.origin}${location.pathname}${
      location.hash ? `${location.hash}` : ""
    }`;
    history.replaceState("", "", cleanPath);

    this.$.root.trigger("filter.change", { params: {} });
  }
  hideCheckedFieldsets() {
    this.$.fields.each((i, fields) => {
      const $fields = $(fields);

      if ($fields.is(".is-checkboxes")) {
        this.toggle($fields, true);
      }
    });
  }
  submit(e) {
    e.stopPropagation();
    e.preventDefault();
  }
  change(e) {
    e.preventDefault();
    e.stopPropagation();

    clearTimeout(this.timer);

    this.timer = setTimeout(() => {
      const params = this.getParams();
      this.setState({ params });
      this.$.root.trigger("filter.change", { params });
    }, this.delay);
  }
  toggle($target, force = null) {
    const $fieldset = $target.closest(classList.fieldset);
    const $fields = $fieldset.find(classList.fields);
    const index = $fieldset.index();

    if (!this.state.animQueue.includes(index)) {
      this.state.animQueue.push(index);

      if ($fieldset.is(".is-open") || (force !== null && force)) {
        $fieldset.removeClass("is-open");
        $fields.slideUp(300, () => {
          this.state.animQueue.splice(this.state.animQueue.length - 1, 1);
          this.reInitScrollbars($fieldset);
        });
      } else {
        $fieldset.addClass("is-open");
        $fields.slideDown(300, () => {
          this.state.animQueue.splice(this.state.animQueue.length - 1, 1);
          this.reInitScrollbars($fieldset);
        });
      }
    }
  }
  reInitScrollbars($fieldset) {
    // if ($fieldset.is(".is-open")) {
    //   const $fields = $fieldset.find(classList.fields);
    //   const scrollbar = $fields.get(0).component;
    //   if (scrollbar) {
    //     nextTick().then(() => {
    //       scrollbar.reInit();
    //     });
    //   }
    // }
  }
  toggleTooltip($target) {
    const $fieldset = $target.closest(classList.fieldset);

    this.$.tooltip.remove();
    $fieldset.append(this.$.tooltip);
    this.$.tooltip.show();
  }
  getParams() {
    const params =
      (!this.inited
      ? Query.merge(null, this.$.root.serialize())
      : Query.parse({ rebuild: true, query: this.$.root.serialize() })) || {};

    // remove empty keys
    for (const key in params) {
      if (params.hasOwnProperty(key)) {
        const param = params[key];

        if (param.length < 1) {
          delete params[key];
        }
      }
    }

    if (this.inited) {
      delete params["page"];
    }

    return params;
  }
}

Component.mount(Filter, {
  name: "Filter",
  classList,
  state: {
    active: false,
    animQueue: [],
    params: {}
  }
});
